import { Button, DialogActions, DialogContent, DialogTitle, Grid } from "@mui/material";
import { useState } from "react";
import { renderClose } from "../../common/dialog";
import { createEntityStore } from "../../common/entityStore";
import { propTextField } from "../../common/entityStoreForm";
import { propLengthMax, propRequired } from "../../common/entityStoreValidators";
import { AdminListEditDto } from "./types";

export const InvoiceStateDialog = (props: {
    close: () => void;
    invoiceStates: AdminListEditDto;
    onChange(): void;
}) => {
    const [{ useInvoiceStatesDialogStore }] = useState(() => {
        const useInvoiceStatesDialogStore = createEntityStore<AdminListEditDto>({
            data: { ...props.invoiceStates },
            path: "settings/invoiceStates",
            fetchOnInit: false,
            id: props.invoiceStates.id,
            onSaved() {
                props.onChange();
                props.close();
            },
            propValidators: [
                propRequired("description"),
                propLengthMax("description", 100),
            ]
        });

        return { useInvoiceStatesDialogStore };
    });

    const { save, isSaveDisabled } = useInvoiceStatesDialogStore(p => ({ save: p.save, id: p.entityId, isSaveDisabled: p.isSaveDisabled }));
    return <>
        <DialogTitle>{`Edit invoice states - ${props.invoiceStates.code}`}</DialogTitle>
        {renderClose(props.close)}
        <DialogContent>
            <Grid container columnSpacing={2} alignItems="stretch">
                <Grid item xs={12}>{propTextField(useInvoiceStatesDialogStore)("description", "Description",)}</Grid>
            </Grid>
        </DialogContent>
        <DialogActions>
            <Button onClick={save} disabled={isSaveDisabled} color="save">Save</Button>
            <Button onClick={props.close} color="negative" variant="outlined">Close</Button>
        </DialogActions>
    </>;
};